module.exports = __webpack_public_path__ + "img/1438326759.9d242172.jpg";